import { GbApiRequestService } from "@/services/ApiRequestService";

export class AutoLoginApi {
  static async send() {
    return GbApiRequestService.post("/rlogin", {
      requestType: "autologin",
    });
  }
}
